/* React */
import React from "react";

/* Ionic */
import { IonRange, RangeCustomEvent } from "@ionic/react";

/* Components */
import FilterLabel from "src/components/shared/labels/filter-label/FilterLabel";
import ValueContainer from "src/components/shared/slider/double-slider/value-container/ValueContainer";

/* Stylesheet */
import styles from "./DoubleSlider.module.scss";

/* Interfaces */
interface DoubleSliderProps {
  scssProps?: ScssProps;
  className?: string;
  label?: string;
  min: number;
  max: number;
  value: { lower: number; upper: number };
  pin: boolean;
  ticks: boolean;
  inputFields?: boolean;
  disabled?: boolean;
  onChange: (value: {
    lower: number;
    upper: number;
  }) => void;
}

interface ScssProps {
  padding?: string;
}

const DoubleSlider: React.FC<DoubleSliderProps> = ({
  scssProps,
  className,
  label,
  min,
  max,
  value,
  pin,
  ticks,
  disabled,
  onChange,
}) => {
  return (
    <div
      style={{
        padding: scssProps?.padding,
      }}
      className={styles.double_slider}
    >
      <FilterLabel label={label!} />
      <IonRange
        className={`${styles.slider} ${
          disabled
            ? styles.disabled
            : styles[className ?? ""]
        }`}
        min={min}
        max={max}
        value={{
          lower: value.lower,
          upper: value.upper,
        }}
        dualKnobs={true}
        pin={pin}
        ticks={ticks}
        step={1}
        aria-label={"Double Slider"}
        disabled={disabled}
        onIonChange={(e: RangeCustomEvent) => {
          let { lower, upper } = e.detail.value as {
            lower: number;
            upper: number;
          };

          if (lower > upper) {
            [lower, upper] = [upper, lower];
          }

          onChange({ lower, upper });
        }}
      />
      <ValueContainer
        className={className}
        min={min}
        max={max}
        value={value}
        disabled={disabled}
        onChange={onChange}
      />
    </div>
  );
};

export default DoubleSlider;
